<div [ngClass]="{ centerOfAll: center }">
  <div class="la-ball-clip-rotate" [class]="size" [style]="{ color: color }">
    <div></div>
  </div>
</div>
